import { Card, CardContent } from '@mui/material';
import { cloneElement, FC, ReactElement } from 'react';
import Popper from '@mui/material/Popper';
import { usePopupState, bindHover, bindPopper } from 'material-ui-popup-state/hooks';
import Fade from '@mui/material/Fade';
import EmailBasicInfoCard from './EmailBasicInfoCard';
import { Email } from '../../ctx/subscriptions/Subscription.Context';

interface IEmailPoper {
  emailData: Email;
  rootElement: ReactElement;
}

const EmailPoper: FC<IEmailPoper> = ({ emailData, rootElement }) => {
  const popupState = usePopupState({ variant: 'popper', popupId: 'demoPopper' });

  return (
    <>
      {cloneElement(rootElement, { ...bindHover(popupState) })}
      <Popper {...bindPopper(popupState)} transition style={{ zIndex: 10000 }}>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Card
              sx={{
                backgroundColor: 'white',
                backdropFilter: 'blur(5px)',
                zIndex: 100,
                maxWidth: '30vw',
              }}
            >
              <CardContent>
                <EmailBasicInfoCard basicEmailInfoData={emailData} />
              </CardContent>
            </Card>
          </Fade>
        )}
      </Popper>
    </>
  );
};
export default EmailPoper;
